import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../public/images/new/secondopinion_jumbotron.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-1d6cf843")

_pushScopeId("data-v-1d6cf843")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("중증질환 ")
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "-royalBlue" }, "2차소견", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 타 병원 암치료, 수술 등 검사파일을 바탕으로 ")
const _hoisted_4 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 전문의 소견이 필요한경우(3~7일 소요) ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("2차 소견 요청")
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "Online Care"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_Jumbotorn = _resolveComponent("Jumbotorn")

  return (_openBlock(), _createBlock(_component_Jumbotorn, null, {
    header: _withId(() => [
      _hoisted_1,
      _hoisted_2
    ]),
    main: _withId(() => [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5
    ]),
    footer: _withId(() => [
      _createVNode(_component_router_link, {
        to: _ctx.linkTo,
        class: "-button -royalBlue -bold"
      }, {
        default: _withId(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    image: _withId(() => [
      _createVNode("figure", {
        class: !!_ctx.isMobileShow ? '' : '-pc'
      }, [
        _hoisted_7
      ], 2)
    ]),
    _: 1
  }))
})